if (!customElements.get('worx-service-tabs')) {
    customElements.define(
        'worx-service-tabs',
        class WorxServiceTabs extends HTMLElement {
            connectedCallback() {
                this.tabs = this.querySelectorAll('[data-worx-service-tab]');
                this.panels = this.querySelectorAll('[data-worx-service-panel]');

                this.tabs.forEach((tab) => {
                    tab.addEventListener('click', this.onTabClick.bind(this));
                    tab.addEventListener('keydown', (event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            this.onTabClick(event);
                        }
                    });
                });
            }

            onTabClick(event) {
                event.preventDefault();
                const tab = event.currentTarget;
                const key = tab.getAttribute('data-worx-service-tab');

                this.tabs.forEach((item) => {
                    item.classList.toggle('is-active', item === tab);
                    item.setAttribute('aria-selected', item === tab ? 'true' : 'false');
                });

                this.panels.forEach((panel) => {
                    const match = panel.getAttribute('data-worx-service-panel') === key;
                    panel.toggleAttribute('hidden', !match);
                    panel.classList.toggle('is-active', match);
                });
            }
        }
    );
}

if (!customElements.get('worx-service-gallery')) {
    customElements.define(
        'worx-service-gallery',
        class WorxServiceGallery extends HTMLElement {
            connectedCallback() {
                this.modeButtons = this.querySelectorAll('[data-worx-gallery-view]');
                this.grid = this.querySelector('[data-worx-gallery-grid]');

                this.modeButtons.forEach((button) => {
                    button.addEventListener('click', this.onViewClick.bind(this));
                    button.addEventListener('keydown', (event) => {
                        if (event.key === 'Enter' || event.key === ' ') {
                            event.preventDefault();
                            this.onViewClick(event);
                        }
                    });
                });
            }

            onViewClick(event) {
                const button = event.currentTarget;
                const view = button.getAttribute('data-worx-gallery-view');

                this.modeButtons.forEach((item) => {
                    item.classList.toggle('active', item === button);
                });

                if (!this.grid) return;
                this.grid.classList.toggle('worx-service__gallery-grid--list', view === 'list');
                this.grid.classList.toggle('worx-service__gallery-grid--grid-2', view === 'grid-2');
            }
        }
    );
}

if (!customElements.get('worx-service-slider')) {
    customElements.define(
        'worx-service-slider',
        class WorxServiceSlider extends HTMLElement {
            connectedCallback() {
                this.viewport = this.querySelector('.worx-service__gallery-slider-viewport');
                this.track = this.querySelector('.worx-service__gallery-slider-track');
                this.source = this.querySelector('[data-worx-slider-source]');
                if (!this.viewport || !this.track || !this.source) return;

                this.fillChain();
                this.querySelectorAll('img').forEach((image) => {
                    if (!image.complete) {
                        image.addEventListener('load', () => this.fillChain(), { once: true });
                    }
                });

                this.resizeObserver = new ResizeObserver(() => this.fillChain());
                this.resizeObserver.observe(this.viewport);
            }

            disconnectedCallback() {
                if (this.resizeObserver) this.resizeObserver.disconnect();
            }

            fillChain() {
                if (this._filling) return;
                if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
                this._filling = true;

                this.track.querySelectorAll('.worx-service__gallery-slider-group:not([data-worx-slider-source])').forEach((group) => {
                    group.remove();
                });

                const viewportWidth = this.viewport.clientWidth;
                if (viewportWidth) {
                    let safety = 0;
                    while (this.track.scrollWidth < viewportWidth && safety < 24) {
                        this.appendClone();
                        safety += 1;
                    }

                    [...this.track.children].forEach((group) => {
                        const clone = group.cloneNode(true);
                        clone.removeAttribute('data-worx-slider-source');
                        clone.classList.add('worx-service__gallery-slider-group--clone');
                        clone.setAttribute('aria-hidden', 'true');
                        this.track.appendChild(clone);
                    });
                }

                this._filling = false;
            }

            appendClone() {
                const clone = this.source.cloneNode(true);
                clone.removeAttribute('data-worx-slider-source');
                clone.classList.add('worx-service__gallery-slider-group--clone');
                clone.setAttribute('aria-hidden', 'true');
                this.track.appendChild(clone);
            }
        }
    );
}
